<template>
<div class="bg-login">
  <div class="bg-login-main">
    <div class="container">
      <div class="row">
        <div class="form-title">{{ $t('login.title') }}</div>
      </div>
      <div class="row bg-login-inner">
      <!-- Login Form -->
      <form class="login form" @submit.prevent="login">
        <div class="form-group">
          <label class="form-label" for="email">{{ $t('login.email') }}</label>
          <input type="text" name="email" required class="form-control"
              :class="{'is-invalid' : error.email}"
              id="email"
              v-model="form.email"
              autocomplete="off"
              :disabled="loading"
              @focus="clearErrors"
              placeholder="john.doe@jelsmethod.com">
          <div class="invalid-feedback" v-show="error.email"><span>{{ error.email }}</span></div>
        </div>
        <div class="form-group">
          <label class="form-label" for="password">{{ $t('login.password') }}</label>
          <input type="password" name="password" required class="form-control"
              :class="{'is-invalid' : error.password}"
              id="password"
              v-model="form.password"
              :disabled="loading"
              placeholder="********"
              autocomplete="off">
          <div class="invalid-feedback" v-show="error.password">{{ error.password }}</div>
        </div>
        <div class="form-group">
          <div class="flex-center">
          <input class="checkbox" id="remember" type="checkbox" name="remember" v-model="form.remember">
          <label class="form-label" for="remember">Remember Me</label>
          </div>
        </div>
          <button type="submit" class="button button-primary" :disabled="loading">
            <span v-show="loading">{{ $t('common.button.login') }}...</span>
            <span v-show="!loading">{{ $t('common.button.login') }}</span>
          </button>
        <div class="form-group">

          <div class="flex-center">
            <div class="form-label password-reset" v-html="$t('login.forgot_password')">
            </div>
          </div>
        </div>
      </form>
      <!-- /Login Form -->
      </div>
    </div>
  </div>
  <div class="bg-login-bottom">
    <div class="container">
      <div class="row bg-login-inner">
        <button type="button" class="button button-default" :disabled="loading" @click.prevent="signUp">
          {{ $t('common.button.signup') }}
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import {api, appEnv} from "../../config";

  export default {
    data() {
      return {
        loading: false,
        form: {
          email: null,
          password: null,
          remember: null
        },
        error: {
          email: null,
          password: null,
          remember: null
        }
      }
    },
    mounted() {
    },
    methods: {
      login() {
        let self = this;
        
        this.loading = true;
        this.error.email = '';
        
        this.$store.dispatch('showLoading', true)
        
        axios.get('/sanctum/csrf-cookie').then(() => {
          axios.post(api.login, this.form)
            .then(res => {
              if(res.data.result) {
                self.loading = false;
                self.$emit('loginSuccess', res.data);
              }

              self.$store.dispatch('showLoading', false)
            })
            .catch(err => {
              (err.response.data.error)
                ? self.setErrors(err.response.data.error)
                : self.clearErrors();
              if(err.response.data.error && err.response.data.error == 'Unauthorized') {
                self.error.email = 'wrong email or password';
              }

              self.loading = false;
              self.$store.dispatch('showLoading', false)
            });
        });
      },
      signUp () {
        console.log(appEnv);
        //if(appEnv == 'production') {
        //  this.$router.push({name: 'blocksignup'});
        //} else {
          window.location.href = '/signup';
        //}
      },
      setErrors(errors) {
        this.error.email = errors.email ? errors.email[0] : null;
        this.error.password = errors.password ? errors.password[0] : null;
      },
      clearErrors() {
        this.error.email = null;
        this.error.password = null;
      }
    }
  }
</script>
